import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MessageText\GetConvertedMessageTextController::__invoke
* @see app/Http/Controllers/MessageText/GetConvertedMessageTextController.php
* @route '/api/message-text/{message_text}/convert'
*/
const GetConvertedMessageTextController = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetConvertedMessageTextController.url(args, options),
    method: 'post',
})

GetConvertedMessageTextController.definition = {
    methods: ["post"],
    url: '/api/message-text/{message_text}/convert',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\MessageText\GetConvertedMessageTextController::__invoke
* @see app/Http/Controllers/MessageText/GetConvertedMessageTextController.php
* @route '/api/message-text/{message_text}/convert'
*/
GetConvertedMessageTextController.url = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { message_text: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { message_text: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            message_text: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        message_text: typeof args.message_text === 'object'
        ? args.message_text.id
        : args.message_text,
    }

    return GetConvertedMessageTextController.definition.url
            .replace('{message_text}', parsedArgs.message_text.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\MessageText\GetConvertedMessageTextController::__invoke
* @see app/Http/Controllers/MessageText/GetConvertedMessageTextController.php
* @route '/api/message-text/{message_text}/convert'
*/
GetConvertedMessageTextController.post = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetConvertedMessageTextController.url(args, options),
    method: 'post',
})

export default GetConvertedMessageTextController